import React from 'react'
export default function Arrow(props) {
    return (
      // <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
      //     className={props.className}
      //     onClick={props.onClick}
      //     viewBox="0 0 17 28">
      //     <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      //         <g transform="translate(-639.000000, -340.000000)" fill="#636466" fillRule="nonzero">
      //             <g transform="translate(639.000000, 285.000000)">
      //                 <path d="M0.386871126,68.0712237 L13.2694492,55.3854931 C13.78344,54.8715023 14.6145741,54.8715023 15.1285649,55.3854931 L15.9050191,56.1619473 C16.4190099,56.6759381 16.4190099,57.5070722 15.9050191,58.021063 L4.71751707,69.0007815 L15.8940831,79.9805 C16.4080739,80.4944908 16.4080739,81.3256249 15.8940831,81.8396157 L15.1176289,82.6160699 C14.6036381,83.1300607 13.7725041,83.1300607 13.2585132,82.6160699 L0.375935152,69.9303393 C-0.127119681,69.4163485 -0.127119681,68.5852145 0.386871126,68.0712237 Z" transform="translate(8.145256, 69.000782) rotate(-360.000000) translate(-8.145256, -69.000782) "></path>
      //             </g>
      //         </g>
      //     </g>
      // </svg>

      <svg
        className={props.className}
        onClick={props.onClick}
        viewBox="0 0 10 19"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(-604.000000, -529.000000)"
            fill="black"
            fillRule="nonzero"
          >
            <path
              d="M613.315392,547.075589 L613.591614,546.799406 C613.774681,546.616377 613.774681,546.319556 613.591614,546.13649 L605.95518,538.500018 L613.591614,530.863546 C613.774681,530.680517 613.774681,530.383697 613.591614,530.20063 L613.315392,529.924446 C613.132363,529.741418 612.835581,529.741418 612.652514,529.924446 L604.408362,538.16856 C604.225295,538.351627 604.225295,538.648409 604.408362,538.831514 L612.652514,547.075628 C612.835581,547.258656 613.132363,547.258656 613.315392,547.075589 Z"
              transform="translate(608.999988, 538.500035) rotate(-360.000000) translate(-608.999988, -538.500035) "
            ></path>
          </g>
        </g>
      </svg>
    );
}